import {useMemo} from 'react';
import {useScayleState} from './useScayleState';

export const useCheckoutBasketItems = () => {
  const {data: scayleState} = useScayleState();

  return useMemo(() => {
    const packages = scayleState?.orderState?.basket?.packages ?? [];

    return packages.flatMap(pkg =>
      pkg.items.map(item => ({
        id: item.id,
        productId: item.productId,
        captchaRequired: item.additionalData?.captchaRequired ?? false,
      })),
    );
  }, [scayleState?.orderState?.basket?.packages]);
};
